module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal-autorizar-pagamento",
    on: {
      "close": function($event) {
        return _vm.$emit('fechar')
      }
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmar.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("\n      Autorizar pagamento\n    ")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-grande"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ordemBancaria"
    }
  }, [_vm._v("Ordem bancária")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordemBancaria),
      expression: "ordemBancaria"
    }],
    staticClass: "numero-ordem-bancaria",
    attrs: {
      "type": "text",
      "name": "ordemBancaria",
      "id": "ordemBancaria",
      "placeholder": "Ex: 2017OB000012",
      "required": ""
    },
    domProps: {
      "value": (_vm.ordemBancaria)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ordemBancaria = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "dataDoPagamento"
    }
  }, [_vm._v("Data do pagamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataDoPagamento),
      expression: "dataDoPagamento"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99/99/9999'),
      expression: "'99/99/9999'"
    }],
    attrs: {
      "type": "text",
      "name": "dataDoPagamento",
      "id": "dataDoPagamento",
      "placeholder": "Ex: 01/01/2017",
      "required": ""
    },
    domProps: {
      "value": (_vm.dataDoPagamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataDoPagamento = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-superior-grande u-margem-inferior-media"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('fechar')
      }
    }
  }, [_vm._v("\n        Voltar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.carregando
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        Confirmar pagamento\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-429176ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/ModalAutorizarPagamento.vue
// module id = 1108
// module chunks = 1